import React, { useState } from "react";
import { Helmet } from "react-helmet";
import axios from "axios";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { BsChevronDown } from "react-icons/bs";
import { ToastContainer, toast } from "react-toastify";
import SubmitBtn from "../../components/buttons/SubmitBtn";
import { educareLogo } from "../../assets";
import { courseTitle } from "../../constants";
import TopBanner from "../../components/designTab/TopBanner";

const Admission = () => {
  let [courseName, setCourseName] = useState("");
  let [clientName, setClientName] = useState("");
  let [email, setEmail] = useState("");
  let [phoneNumber, setPhoneNumber] = useState("");
  let [successMsg, setSuccessMsg] = useState("");
  // ========== Email Validation start here ==============
  const emailValidation = (email) => {
    return String(email)
      .toLocaleLowerCase()
      .match(/^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/);
  };
  // ========== Email Validation end here ================

  const handleAdmission = (e) => {
    e.preventDefault();
    if (courseName === "") {
      toast.error("Please select your course");
    } else if (clientName === "") {
      toast.error("Enter your Full Name");
    } else if (email === "") {
      toast.error("Enter your Email Address");
    } else if (!emailValidation(email)) {
      toast.error("Give a Valid Email Address");
    } else if (phoneNumber === "") {
      toast.error("Provide your Phone Number");
    } else {
      axios.post("https://getform.io/f/bf5b529d-dd07-4257-a891-ea9c539ededa", {
        course: courseName,
        name: clientName,
        email: email,
        phone: phoneNumber,
      });
      setSuccessMsg(
        `Hello dear ${clientName}, We received your message successfully. You will receive further details in your email at ${email} and our Admission team member will contact with you shortly. Thank you for your time.`
      );
      setCourseName("");
      setClientName("");
      setEmail("");
      setPhoneNumber("");
    }
  };
  return (
    <div className="w-full h-auto">
      <Helmet>
        <title>Admission - EduCare English Learning Academy</title>
      </Helmet>
      <TopBanner titleText="Admission" />
      <div className="max-w-screen-xl h-auto mx-auto pt-4 pb-20">
        <form
          id="form"
          action="https://getform.io/f/fb9d1b74-60fe-4058-98a2-f9b4b1032ea5"
          method="POST"
          className="w-full lg:w-3/4 shadow-2xl shadow-primeColor hover:shadow-darkPink transition-hover duration-300 mx-auto h-full flex flex-col justify-top py-10 lg:py-20 px-4 md:px-20 lg:px-32 items-start gap-5"
        >
          <div className="w-full flex flex-col md:flex-row justify-center gap-4 lgl:gap-0 lgl:justify-between items-center mb-2 lgl:mb-10">
            <Link to="/">
              <img src={educareLogo} className="w-52" alt="educareLogo" />
            </Link>
            <h2 className="font-titleFont text-2xl font-semibold underline underline-offset-4">
              Admission Form
            </h2>
          </div>
          {successMsg ? (
            <div className="w-full bg-darkPink p-6 text-white rounded-md">
              <motion.p
                initial={{ x: 50, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{
                  delay: 0.2,
                  x: { type: "spring", stiffness: 60 },
                  opacity: { duration: 1 },
                  ease: "easeIn",
                  duration: 1,
                }}
                className="font-titleFont text-lg font-semibold"
              >
                {successMsg}
              </motion.p>
            </div>
          ) : (
            <>
              <div className="flex flex-col gap-5 w-full relative">
                <select
                  value={courseName}
                  onChange={(e) => setCourseName(e.target.value)}
                  className="bg-primeColor shadow-md shadow-primeColor outline-none focus:shadow-darkPink font-bodyFont cursor-pointer text-white py-2 px-6 rounded-md text-lg appearance-none "
                >
                  {courseTitle.map((course) => (
                    <option
                      value={course.title}
                      className="w-full h-full bg-primeColor bg-opacity-80 cursor-pointer"
                      key={course.id}
                    >
                      {course.title}
                    </option>
                  ))}
                </select>
                <span className="absolute top-3 text-white text-xl right-6 cursor-pointer">
                  <BsChevronDown />
                </span>

                <input
                  onChange={(e) => setClientName(e.target.value)}
                  value={clientName}
                  className="bg-primeColor shadow-md shadow-primeColor outline-none focus:shadow-darkPink font-bodyFont text-white py-2 px-6 rounded-md text-lg w-full h-auto placeholder:text-gray-300"
                  type="text"
                  placeholder="Enter your Full Name"
                />

                <input
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  className="bg-primeColor shadow-md shadow-primeColor outline-none focus:shadow-darkPink font-bodyFont text-white py-2 px-6 rounded-md text-lg w-full h-auto placeholder:text-gray-300"
                  type="email"
                  placeholder="Enter your Email"
                />

                <input
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  value={phoneNumber}
                  className="bg-primeColor shadow-md shadow-primeColor outline-none focus:shadow-darkPink appearance-none font-bodyFont text-white py-2 px-6 rounded-md text-lg w-full h-auto placeholder:text-gray-300"
                  type="tel"
                  placeholder="Enter your Phone Number"
                />
              </div>
              <div
                onClick={handleAdmission}
                className="shadow-md w-full md:w-auto shadow-primeColor rounded-md hover:shadow-darkPink"
              >
                <SubmitBtn />
              </div>
            </>
          )}
        </form>

        <ToastContainer
          position="top-center"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
      </div>
    </div>
  );
};

export default Admission;
